import React, { useState } from "react";

const codeSnippets = [
    {
        code: `function add(a, b) {
  return a + b;
}`,
        options: ["Somma due numeri", "Moltiplica due numeri", "Sottrae due numeri"],
        correct: 0,
        explanation: "Questa funzione somma due parametri a e b"
    },
    {
        code: `const arr = [1, 2, 3];
arr.map(x => x * 2);`,
        options: ["Filtra l'array", "Raddoppia ogni elemento", "Somma gli elementi"],
        correct: 1,
        explanation: "map() trasforma ogni elemento moltiplicandolo per 2"
    },
    {
        code: `if (x > 10) {
  console.log("Grande");
}`,
        options: ["Stampa se x è maggiore di 10", "Stampa sempre", "Controlla se x è uguale a 10"],
        correct: 0,
        explanation: "Il codice verifica se x supera il valore 10"
    },
    {
        code: `const obj = { name: "Mario" };
console.log(obj.name);`,
        options: ["Stampa undefined", "Stampa 'Mario'", "Genera errore"],
        correct: 1,
        explanation: "Accede alla proprietà name dell'oggetto"
    },
    {
        code: `for (let i = 0; i < 3; i++) {
  console.log(i);
}`,
        options: ["Stampa 0, 1, 2", "Stampa 1, 2, 3", "Stampa 3 volte 0"],
        correct: 0,
        explanation: "Il loop stampa i da 0 a 2 (escluso 3)"
    }
];

export default function CodeGuess() {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [started, setStarted] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);

    const handleAnswer = (index) => {
        setSelectedAnswer(index);
        if (index === codeSnippets[currentQuestion].correct) {
            setScore(score + 1);
        }
        setShowExplanation(true);

        setTimeout(() => {
            if (currentQuestion + 1 < codeSnippets.length) {
                setCurrentQuestion(currentQuestion + 1);
                setSelectedAnswer(null);
                setShowExplanation(false);
            } else {
                setShowResult(true);
            }
        }, 2500);
    };

    const restart = () => {
        setCurrentQuestion(0);
        setScore(0);
        setShowResult(false);
        setSelectedAnswer(null);
        setStarted(false);
        setShowExplanation(false);
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-code" style={{marginRight:"6px"}}></i> Code Guess
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Indovina cosa fa il codice mostrato!</p>
                <button
                    onClick={() => setStarted(true)}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (showResult) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score}/{codeSnippets.length}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === codeSnippets.length && "🎉 Perfetto! Conosci il codice!"}
                    {score >= 3 && score < codeSnippets.length && "👍 Ottimo! Continua così!"}
                    {score < 3 && "💻 Continua a programmare!"}
                </p>
                <button
                    onClick={restart}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Riprova
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Snippet {currentQuestion + 1} di {codeSnippets.length}
            </div>

            <pre style={{
                background:"rgba(0,0,0,0.4)",
                padding:"1rem",
                borderRadius:"0.5rem",
                textAlign:"left",
                fontSize:"0.75rem",
                color:"#00ffa3",
                marginBottom:"1rem",
                overflow:"auto",
                fontFamily:"monospace"
            }}>
                {codeSnippets[currentQuestion].code}
            </pre>

            <h4 style={{color:"#facc15", marginBottom:"1rem", fontSize:"0.9rem"}}>
                Cosa fa questo codice?
            </h4>

            <div style={{display:"flex", flexDirection:"column", gap:"0.8rem"}}>
                {codeSnippets[currentQuestion].options.map((option, index) => {
                    const isSelected = selectedAnswer === index;
                    const isCorrect = index === codeSnippets[currentQuestion].correct;
                    const showFeedback = selectedAnswer !== null;

                    return (
                        <button
                            key={index}
                            onClick={() => selectedAnswer === null && handleAnswer(index)}
                            disabled={selectedAnswer !== null}
                            style={{
                                padding:"0.8rem",
                                borderRadius:"0.5rem",
                                border: showFeedback
                                    ? (isCorrect ? "2px solid #22c55e" : isSelected ? "2px solid #ef4444" : "1px solid rgba(255,255,255,0.1)")
                                    : "1px solid rgba(255,255,255,0.1)",
                                background: showFeedback
                                    ? (isCorrect ? "rgba(34,197,94,0.2)" : isSelected ? "rgba(239,68,68,0.2)" : "rgba(255,255,255,0.05)")
                                    : "rgba(255,255,255,0.05)",
                                color:"#fff",
                                cursor: selectedAnswer === null ? "pointer" : "default",
                                fontSize:"0.85rem",
                                transition:"all 0.3s ease",
                                textAlign:"left"
                            }}
                        >
                            {showFeedback && isCorrect && <i className="fas fa-check" style={{marginRight:"6px", color:"#22c55e"}}></i>}
                            {showFeedback && isSelected && !isCorrect && <i className="fas fa-times" style={{marginRight:"6px", color:"#ef4444"}}></i>}
                            {option}
                        </button>
                    );
                })}
            </div>

            {showExplanation && (
                <div style={{
                    marginTop:"1rem",
                    padding:"0.8rem",
                    background:"rgba(34,197,94,0.1)",
                    borderRadius:"0.5rem",
                    fontSize:"0.8rem",
                    color:"#94a3b8",
                    border:"1px solid rgba(34,197,94,0.3)"
                }}>
                    <i className="fas fa-info-circle" style={{marginRight:"6px", color:"#22c55e"}}></i>
                    {codeSnippets[currentQuestion].explanation}
                </div>
            )}
        </div>
    );
}